<div>
  <app-header></app-header>
    <mat-horizontal-stepper [linear]="true" #stepper>
      <mat-step>
        <ng-template matStepLabel>{{"ORDER.WEBID.LABEL" | translate}}</ng-template>
        <mat-card *ngIf="webIdAction" class="step-card">
          <mat-card-header>
            <mat-card-title>
              <h3>{{"ORDER.WEBID.TITLE" | translate}}</h3>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content class="margin-left-16px">
            <span>
              {{"ORDER.WEBID.TEXT" | translate}}
              <br /><br />
              <h3>{{"ORDER.WEBID.FOLLOWURL" | translate}}</h3>
              <a href="{{webIdAction.url}}" target="_blank">
                <button mat-raised-button type="button" color="primary" style="border-radius: 50px;">{{"ORDER.WEBID.BUTTONTEXT" | translate}}</button></a>
              <br>
              <h5>{{"ORDER.WEBID.EXPIRATIONDATE" | translate}}{{webIdAction.approximateDateOfExpiry | date: 'full': 'UTC'}}
              </h5>
              <h3>{{"ORDER.WEBID.DOWNLOADWEBID" | translate}}</h3>
              <div>
                <div class="text-center">
                  <a href="https://itunes.apple.com/us/app/webident/id1016629510?ls=1&amp;mt=8" target="_blank">
                    <img src="./../../../assets/img/app-store-badge.svg" height="30px" alt="WebIDent">
                  </a>
                </div>
                <div class="text-center">
                  <a href="https://play.google.com/store/apps/details?id=de.webidsolutions.mywebid" target="_blank">
                    <img src="./../../../assets/img/google-play-badge.svg" height="30px" alt="WebIDent">
                  </a>
                </div>
              </div>
              <br>
              <h5>{{"ORDER.WEBID.TRANSACTIONID" | translate}}{{webIdAction.actionId}}</h5>
              <h6 class="red-text">{{"ORDER.WEBID.TEXTINRED" | translate}}</h6>
            </span>
          </mat-card-content>
          <mat-card-actions align="end">
          </mat-card-actions>
        </mat-card>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>{{"ORDER.SUMMARY.LABEL" | translate}}</ng-template>
        <mat-card class="step-card" *ngIf="webIdResponse == true">
          <mat-card-header>
            <mat-card-title>
              {{"ORDER.SUMMARY.SUCCESS.TITLE" | translate}}
            </mat-card-title>
          </mat-card-header>
          <mat-card-content class="margin-left-16px">
            <div>
              {{"ORDER.SUMMARY.DEAR" | translate}} {{summaryPageUserAddressing?.title}} {{summaryPageUserAddressing?.firstName}} {{summaryPageUserAddressing?.lastName}},<br>
              {{"ORDER.SUMMARY.SUCCESS.TEXT" | translate}}
              <a href="mailto:support@cardcompact.com">support@cardcompact.com</a>
            </div>
          </mat-card-content>
          <mat-card-actions align="end">
          </mat-card-actions>
        </mat-card>
        <mat-card class="step-card" *ngIf="webIdResponse == false">
          <mat-card-header>
            <mat-card-title>
              {{"ORDER.SUMMARY.FAIL.TITLE" | translate}}
            </mat-card-title>
          </mat-card-header>
          <mat-card-content class="margin-left-16px">
            <div>
              {{"ORDER.SUMMARY.DEAR" | translate}} {{summaryPageUserAddressing?.title}} {{summaryPageUserAddressing?.firstName}} {{summaryPageUserAddressing?.lastName}},<br>
              {{"ORDER.SUMMARY.FAIL.TEXT" | translate}}
              <a href="mailto:support@cardcompact.com">support@cardcompact.com</a>
            </div>
          </mat-card-content>
          <mat-card-actions align="end">
          </mat-card-actions>
        </mat-card>
        <mat-card class="step-card" *ngIf="webIdResponse != false && webIdResponse != true">
          <mat-card-header>
            <mat-card-title>
              {{"ORDER.SUMMARY.LOSTCONNECTION.TITLE" | translate}}
            </mat-card-title>
          </mat-card-header>
          <mat-card-content class="margin-left-16px">
            <div>
              {{"ORDER.SUMMARY.DEAR" | translate}} {{summaryPageUserAddressing?.title}} {{summaryPageUserAddressing?.firstName}} {{summaryPageUserAddressing?.lastName}},<br>
              {{"ORDER.SUMMARY.LOSTCONNECTION.TEXT" | translate}}
              <a href="mailto:support@cardcompact.com">support@cardcompact.com</a>
            </div>
          </mat-card-content>
          <mat-card-actions align="end">
          </mat-card-actions>
        </mat-card>
      </mat-step>
    </mat-horizontal-stepper>
</div>
